import { useEffect, useState } from "react";
import { useInactivity } from "../context/InactivityContext";

const InactivityWarningModal = () => {
  const { remainingTime } = useInactivity();
  const [minutes, setMinutes] = useState(1);
  const [seconds, setSeconds] = useState(0);

  // Update the countdown timer
  useEffect(() => {
    const updateTimer = () => {
      const mins = Math.floor(remainingTime / 60000);
      const secs = Math.floor((remainingTime % 60000) / 1000);
      setMinutes(mins);
      setSeconds(secs);
    };

    updateTimer();
    const interval = setInterval(updateTimer, 1000);
    return () => clearInterval(interval);
  }, [remainingTime]);

  // Prevent body scroll when modal is open
  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "unset";
    };
  }, []);

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(0, 0, 0, 0.7)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 999998,
      }}
    >
      <div
        style={{
          backgroundColor: "white",
          padding: "40px",
          borderRadius: "8px",
          textAlign: "center",
          maxWidth: "400px",
          boxShadow: "0 4px 20px rgba(0, 0, 0, 0.15)",
        }}
      >
        <h2
          style={{
            margin: "0 0 20px 0",
            color: "#333",
            fontSize: "24px",
          }}
        >
          Session Expiring Soon
        </h2>
        <p
          style={{
            margin: "0 0 10px 0",
            color: "#666",
            fontSize: "16px",
            lineHeight: "1.5",
          }}
        >
          Your session will expire in{" "}
          <strong style={{ color: "#dc3545", fontSize: "20px" }}>
            {minutes}:{seconds.toString().padStart(2, "0")}
          </strong>{" "}
          minutes due to inactivity.
        </p>
        <p
          style={{
            margin: "20px 0 0 0",
            color: "#666",
            fontSize: "14px",
            fontStyle: "italic",
          }}
        >
          Any activity will reset the timer and close this message.
        </p>
      </div>
    </div>
  );
};

export default InactivityWarningModal;
